import instance from './axiosThree.js'

// 门店登录接口
export function storeLogin(data) {
    return instance.post('/open/v3/login_check', data)
}

//获取门店分销接口
export function distribution() {
    return instance.post(`/shop/get_distribution`)
}

// 修改三级分销佣金绑定
export function edit_distribution(firstDistribution, secondDistribution, thirdDistribution) {
    return instance.post(`/shop/edit_distribution?firstDistribution=${firstDistribution}&secondDistribution=${secondDistribution}&thirdDistribution=${thirdDistribution}`)
}
//新增兑换商城接口
export function mallAdd(data) {
  return instance.post('/lottery_goods/add', data)
}
// 轮播图列表数据
export function carouseList(data) {
    return instance.post('/slide_show/page', data)
}

// 华为云图片上传接口
export function picUpload(data) {
    return instance.post('/open/upload_file', data)
}

// 轮播图添加数据
export function carouseAddList(data) {
    return instance.post('/slide_show/add', data)
}

// 轮播图删除数据
export function delCarouseList(data) {
    return instance.post('/slide_show/batch_deleted', data)
}

// 轮播图修改数据
export function updateCarouseList(data) {
    return instance.post('/slide_show/update', data)
}

// 代币套餐列表
export function getSeachList(limit, page, typeId, typeSonId, name) {
    return instance.get(`goods/list_data?limit=${limit}&page=${page}&typeId=${typeId}&typeSonId=${typeSonId}&name=${name}`)
}
// 代币套餐列表
export function getTokensList(limit, page, typeId, typeSonId) {
    return instance.get(`goods/list_data?limit=${limit}&page=${page}&typeId=${typeId}&typeSonId=${typeSonId}`)
}

// 套餐操作日志列表
export function listGoodsMallLog(limit, page,operationType) {
  return instance.get(`goods/list_goods_mall_log?limit=${limit}&page=${page}&operationType=${operationType}`)
}

// 套餐操作日志详情
export function infoGoodsMallLog(id) {
  return instance.get(`goods/info_goods_mall_log?id=${id}`)
}

// 新增代币套餐列表
export function addTokensList(data) {
    return instance.post('goods/add_edit', data)
}

// 编辑代币套餐列表
export function editTokensList(data) {
    return instance.post('goods/add_edit', data)
}

// 新增代币套餐列表
export function detailTokensList(objId) {
    return instance.get(`goods/info?objId=${objId}`)
}
// 套餐推荐开关
export function storeRecommend(id,isBoolean) {
    return instance.get(`goods/edit_recommend?id=${id}&isBoolean=${isBoolean}`
    )
}

// 删除代币套餐列表
export function delTokensList(objId) {
    return instance.get(`goods/del?objId=${objId}`)
}

// 批量删除代币套餐列表
export function delsTokensList(idList) {
    return instance.post('goods/batch_del', idList)
}

// 兑换商品管理新增京东列表
export function addGoodsList() {
    return instance.get(`jd/list_data`)
}

// 兑换商品管理新增京东列表下一页
export function addGoodsListNext(scrollId) {
    return instance.get(`jd/list_data?scrollId=${scrollId}`)
}

// 兑换商品管理新增京东列表seach
export function addGoodsListSeach(skuName) {
    return instance.get(`jd/list_data?skuName=${skuName}`)
}

// 砍价商品
export function bargainingList(data) {
    return instance.post(`goods/activity_page`, data)
}

// 管理活动列表
export function ManageList(data) {
    return instance.post('main_activity/page', data)
}

// 管理活动列添加
export function addManageList(data) {
    return instance.post('main_activity/add', data)
}

// 管理活动列删除
export function delManageList(idList) {
    return instance.post('main_activity/deleted', idList)
}

// 管理活动列编辑
export function editManageList(data) {
    return instance.post('main_activity/update', data)
}

// 管理活动列编辑详情
export function detailsManageList(id) {
    return instance.get(`main_activity/info?id=${id}`)
}

// 管理活动列报名详情
export function signManageList(data) {
    return instance.post(`user_activity/page`, data)
}

// 信息推送(8.砍价;10.拼团;4.活动预约通知;5.现金立减券即将过期提醒;6.秒杀活动开始提醒；9.秒杀上架通知)
export function mesPush(id, type) {
    return instance.get(`user_activity/message?id=${id}&type=${type}`)
}

// 优惠券数据列表
export function couponsList(data) {
    return instance.post('shop_discount_voucher/list_data', data)
}

// 优惠券数据列表新增
export function addCouponsList(data) {
    return instance.post('shop_discount_voucher/coupon/add_edit', data)
}

// 优惠券数据列表编辑
export function updateCouponsList(data) {
    return instance.post('shop_discount_voucher/coupon/add_edit', data)
}

// 优惠券数据列表删除
export function delCouponsList(objId) {
    return instance.get(`shop_discount_voucher/del?objId=${objId}`)
}

// 优惠券数据列表用户使用详情
export function userDetailsCouponsList(data) {
    return instance.post(`shop_discount_voucher/use_list`, data)
}

// 任务管理列表
export function TaskList(data) {
    return instance.post('task/page', data)
}

// 任务管理新增接口
export function addTaskList(data) {
    return instance.post('task/add', data)
}

// 任务管理新增编辑
export function updateTaskList(data) {
    return instance.post('task/update', data)
}

// 任务管理删除接口
export function delTaskList(id) {
    return instance.post(`task/batch_deleted?id=${id}`, )}

// 兑换商品管理管理列表数据
export function ExchangeList(data) {
    return instance.post('lottery_goods/page', data)
}

// 兑换商品管理管理新增
export function addExchangeList(data) {
    return instance.post('lottery_goods/add', data)
}

// 兑换商品管理管理编辑
export function editExchangeList(data) {
    return instance.post('lottery_goods/update', data)
}

// 兑换商品管理管理删除
export function delExchangeList(id) {
    return instance.get(`lottery_goods/deleted?id=${id}`)
}

// 门店钱包列表数据
export function storeWalletList(limit, page) {
    return instance.get(`finance_clear/list_data?limit=${limit}&page=${page}`)
}

// 门店钱包列表数据查询
export function storeWalletListSeach(limit, page, financeNo, moneyAdd) {
    return instance.get(`finance_clear/list_data?limit=${limit}&page=${page}&financeNo=${financeNo}&moneyAdd=${moneyAdd}`)
}

// 门店钱包列表提现功能
export function storeTixianWalletList(data) {
    return instance.post(`finance_clear/withdrawal`, data)
}

// 门店钱包列表提现开户银行下拉框
export function storeTixianWalletListdropDown() {
    return instance.get(`finance_clear/bank_list`)
}

// 门店钱包获取余信息
export function storeWalletListDetail() {
    return instance.get(`finance_clear/balance_info`)
}

// 砍价商品新增
export function addBbargainingGoodList(data) {
    return instance.post('goods/add_edit', data)
}

// 砍价商品新增明细
export function bargainingGoodListDetails(objId) {
    return instance.get(`goods/info?objId=${objId}`)
}

// 拼团订单列表
export function groupOrderList(limit, page) {
    return instance.get(`order_mall_pt/list_data?limit=${limit}&page=${page}&shopId=${sessionStorage.getItem("shopId")} `)
}

// 拼团订单列表查询
export function groupOrderListSeach(limit, page, userUid, orderNo, endTime, createTime) {
    return instance.get(`order_mall_pt/list_data?limit=${limit}&page=${page}&userUid=${userUid}&orderNo=${orderNo}&endTime=${endTime}&createTime=${createTime}&shopId=${sessionStorage.getItem("shopId")} `)
}

// 拼团成员订单列表
export function groupOrderListMmber(limit, page, orderNo) {
    return instance.get(`order_mall_pt/list_data_all?limit=${limit}&page=${page}&orderNo=${orderNo}`)
}

// 砍价订单列表
export function bargainingOrderList(limit, page) {
    return instance.get(`order_mall_cut/list_data?limit=${limit}&page=${page}`)
}

// 砍价订单列表查询
export function bargainingOrderListSeach(params) {
    return instance.get(`order_mall_cut/list_data`,{
        params: params
    })
}

// 砍价成员订单列表
export function bargainingOrderListMmber(limit, page, cutNo) {
    return instance.get(`order_mall_cut/list_joiner_data?limit=${limit}&page=${page}&cutNo=${cutNo}&shopId=${sessionStorage.getItem("shopId")}`)
}

// 代币套餐列表数据
export function tokenOrderList(limit, page) {
    return instance.get(`order/list_data?limit=${limit}&page=${page}&goodsTypeSonId=${654}&shopId=${sessionStorage.getItem("shopId")}`)
}

// 代币套餐列表数据查询
export function tokenOrderListSeach(limit, page, orderNo, userUid, endDate, startDate) {
    return instance.get(`order/list_data?limit=${limit}&page=${page}&orderNo=${orderNo}&userUid=${userUid}&endDate=${endDate}&startDate=${startDate}&goodsTypeSonId=${654}&shopId=${sessionStorage.getItem("shopId")}`)
}

// 门票套餐列表数据
export function ticketOrderList(limit, page) {
    return instance.get(`order/list_data?limit=${limit}&page=${page}&goodsTypeSonId=${655}&shopId=${sessionStorage.getItem("shopId")}`)
}

// 门票套餐列表数据查询
export function ticketOrderListSeach(limit, page, orderNo, userUid, endDate, startDate) {
    return instance.get(`order/list_data?limit=${limit}&page=${page}&orderNo=${orderNo}&userUid=${userUid}&endDate=${endDate}&startDate=${startDate}&goodsTypeSonId=${655}&shopId=${sessionStorage.getItem("shopId")}`)
}

// 已支付列表数据
export function payForOrderList(limit, page,) {
    return instance.get(`order/list_data?limit=${limit}&page=${page}&statusUser=${1401}&shopId=${sessionStorage.getItem("shopId")}`)
}

// 已支付列表数据查询
export function payForOrderListSeach(limit, page, orderNo, userUid, endDate, startDate) {
    return instance.get(`order/list_data?limit=${limit}&page=${page}&orderNo=${orderNo}&userUid=${userUid}&endDate=${endDate}&startDate=${startDate}&statusUser=${1401}&shopId=${sessionStorage.getItem("shopId")}`)
}

// 秒杀列表数据
export function seckillOrderList(limit, page) {
    return instance.get(`order/list_data_spike?limit=${limit}&page=${page}&shopId=${sessionStorage.getItem("shopId")}`)
}

// 秒杀列表数据查询
export function seckillOrderListSeach(limit, page, orderNo, userUid, endDate, startDate) {
    return instance.get(`order/list_data_spike?limit=${limit}&page=${page}&orderNo=${orderNo}&userUid=${userUid}&endDate=${endDate}&startDate=${startDate}&shopId=${sessionStorage.getItem("shopId")}`)
}

// 用户签到记录
export function userSignin(data) {
    return instance.post(`sign/user_sign_list`, data)
}

// 完成任务记录
export function complete(data) {
    return instance.post(`task/user_task_list`, data)
}

// 签名配置表
export function qianmignList() {
    return instance.post(`sign/page`)
}

// 砍价商品新增
export function bargainingAdd(data) {
    return instance.post(`goods/add_activity_goods`, data)
}

// 砍价商品删除活动
export function delBargaining(id) {
    return instance.get(`goods/deleted_activity?id=${id}`)
}

// 门票套餐下拉框接口,项目名称
export function ticketXiala(data) {
    return instance.post('project/page', data)
}

// 门店首页销售额
export function storeMainSales() {
    return instance.get('common/totals_sales')
}

// 首页报表数据接口
export function MainReportSales() {
    return instance.get('common/activity_form')
}

// 首页报表数据表单
export function MainTabels() {
    return instance.get('common/activity_form')
}

// 首页会员统计
export function storeMembers() {
    return instance.get('common/totals_member')
}

// 门店协议接口
export function storeAgreement(type) {
    return instance.post(`common/text_info?type=${type}`)
}
// 门店协议接口
export function updateuserDetails(data) {
    return instance.post(`common/update_text`, data)
}

// 门店首页站内信
export function storeMainLetter(limit, page) {
    return instance.get(`common_message/message?limit=${limit}&page=${page}`)
}

// 门店兑换订单列表
export function storeExchange(data) {
    return instance.post('order_lottery/page', data)
}

// 门店兑换订单确认领取
export function storeExchangeTrue(data) {
    return instance.post('order_lottery/affirm', data)
}

// 门店兑换订单取消订单
export function storeExchangeFalse(data) {
    return instance.post('order_lottery/cancel', data)
}

// 门店兑换订单订单详情
export function storeExchangeOrderDetails(orderNo) {
    return instance.get(`order_lottery/info?orderNo=${orderNo}`)
}

// 门店订单管理订单详情接口
export function storeOrderDetails(orderNo) {
    return instance.get(`order/info_detail?orderNo=${orderNo}`)
}

// 门店投币数量
export function storeCoinnum(data) {
    return instance.post('/shop/goods_package_type/list_data', data)
}

// 门店投币数量新增
export function storeCoinnumAdd(data) {
    return instance.post('/shop/goods_package_type/add', data)
}

// 门店投币数量更新
export function storeCoinnumUpdate(data) {
    return instance.post('/shop/goods_package_type/update', data)
}

// 门店投币数量删除
export function storeCoinnumDel(data) {
    return instance.post('/shop/goods_package_type/del', data)
}

// 启用投币数量
export function storeCoinnumEnable(isUse, id) {
    return instance.post(`/shop/goods_package_type/enable?isUse=${isUse}&iconId=${id}`)  
}
// 清除占用的机台
export function clearDeviceNo(deviceNo) {
    return instance.post(`/shop/goods_package_type/del_device?deviceNo=${deviceNo}`)  
}

// 获取机台占用情况
export function getDeviceNo(data) {
    return instance.post(`/shop/goods_package_type/using_device_all`,data)
}

// 获取门店功能
export function storeFunctionList(id) {
    return instance.get(`/shop/goods_package_type/get_by_shop_id?iconId=${id}`)
}

// 首页订单统计
export function storeMainOrder() {
    return instance.get("common/count_order")
}

// 门店二维码
export function createCode() {
    return instance.get("main/create_code")
}

// 门店小程序码
export function createCodes() {
    return instance.get("main/create_wx_code")
}

// 首页报表接口,统计图
export function storeMainInfo(data) {
    return instance.post("common/info", data)
}

// 门店项目管理列表接口
export function storeClassification(data) {
    return instance.post("project/page", data)
}

// 门店项目管理列表新增接口
export function storeClassificationAdd(data) {
    return instance.post("project/add", data)
}

// 门店项目管理列表删除接口
export function storeClassificationDel(id) {
    return instance.get(`project/deleted?id=${id}`)
}

// 门店项目管理列表编辑接口
export function storeClassificationEdit(data) {
    return instance.post("project/update", data)
}

// 门店分销商审核列表数据
export function storeDistributorsList(data) {
    return instance.post("settle_distribution/page", data)
}

// 门店分销商审核列表更新数据
export function storeDistributorsListUpdate(data) {
    return instance.post("settle_distribution/update", data)
}

// 门店分销商审核列表明细数据
export function storeDistributorsListInfo(objId) {
    return instance.get(`settle_distribution/info?objId=${objId}`)
}

// 门店分销商审核列表下拉数据
export function storeDistributorsListXiala() {
    return instance.get('settle_distribution/shop_list')
}

// 门店分销商审核列表审核数据
export function storeDistributorsListSettle(data) {
    return instance.post('settle_distribution/settle', data)
}

// 门店管理商品是否上下架
export function storeUpdown(objId, shelf) {
    return instance.get(`goods/shelf_recommend?objId=${objId}&shelf=${shelf}`)
}

// 门店活动管理是否开启
export function storeActivity(data) {
    return instance.post(`main_activity/update`, data)
}

// 门店优惠券管理是否开启
export function storeCoupons(objId, shelf) {
    return instance.get(`shop_discount_voucher/change_shelf?objId=${objId}&shelf=${shelf}`)
}

// 门店优惠券管理明细
export function storeCouponsDetalis(id) {
    return instance.get(`shop_discount_voucher/info?id=${id}`)
}

// 门店优惠券管理明细
export function storeExchangessss(id, sold) {
    return instance.get(`lottery_goods/update_sold?id=${id}&sold=${sold}`)
}

// 门店权限管理列表
export function storePermissions(data) {
    return instance.post(`login_check/list_data`, data)
}

// 门店权限管理列表新增
export function storePermissionsAdd(data) {
    return instance.post(`login_check/add_user`, data)
}

// 门店权限管理列表编辑
export function storePermissionsEdit(data) {
  return instance.post(`login_check/edit_user`, data)
}

// 门店权限管理列表新增下拉框
export function storePermissionsXiala() {
    return instance.get(`menu/role_list`)
}

// 门店权限管理列表删除
export function storePermissionsDel(phone) {
    return instance.get(`login_check/del?phone=${phone}`)
}

// // 门店权限管理列表删除
// export function storePermissions(data) {
//     return instance.post(`login_check/del`, data)
// }

// 门店签到记录数据
export function SigninRecord() {
    return instance.post(`sign/page`)
}

// 门店签到记录数据修改
export function SigninRecordEdit(data) {
    return instance.post(`sign/edit`, data)
}

// 门店角色管理列表
export function storePermissionsList(data) {
    return instance.post(`menu/role_page`, data)
}

// 门店角色管理列表禁用
export function storePermissionsListDisable(roleId, status) {
    return instance.get(`menu/role_status?roleId=${roleId}&status=${status}`)
}

// 门店角色管理列表新增树形控件
export function storePermissionsListAdd() {
    return instance.get(`menu/get_all_route`)
}

// 门店角色管理列表新增树形控件创建角色
export function storePermissionsListCreate(data) {
    return instance.post(`menu/binding`, data)
}

// 门店角色管理列表删除角色
export function storePermissionsListDel(id) {
    return instance.get(`menu/deleted_role?id=${id}`)
}

// 门店角色管理列表编辑角色
export function storePermissionsListEdit(data) {
    return instance.post(`menu/update_role_menu`, data)
}

// 获取角色已选中的权限
export function getRoleMenuByRoleId(roleId) {
  return instance.get(`menu/get_role_menu?roleId=${roleId}`)
}

// 门店角色管理列表批量删除角色
export function storePermissionsListDels(idList) {
    return instance.post(`menu/batch_deleted_role`, idList)
}

// 门店角色管理角色明细
export function storePermissionsListDetails(roleId) {
    return instance.get(`menu/role_info?roleId=${roleId}`)
}

// 门店轮播图状态修改
export function storeCarouseEdit(data) {
    return instance.post(`slide_show/update`, data)
}

// 门店轮播图编辑明细
export function storeCarouseInfo(id) {
    return instance.get(`slide_show/info?id=${id}`)
}

// 首页消息已读
export function storeMainMessage(messageIds) {
    return instance.get(`common_message/message_read?messageIds=${messageIds}`)
}
export function categoryAddL(data) {
  return instance.post(`goods_lottery/category/add`,data)
}
//商品列表分类
export function categoryList(data) {
  return instance.get(`goods_lottery/category/list?limit=${data.limit}&page=${data.page}`)
}
//删除分类
export function categoryDel(id) {
  return instance.get(`goods_lottery/category/del?id=${id}`)
}
//修改
export function categoryEdit(data) {
  return instance.post(`goods_lottery/category/edit`,data)
}
//查询二维码
export function wechatQrCode(shopId) {
  return instance.post(`wechatQrCode/info?shopId=${shopId} `)
}
//分销报表明细
export function shopListDetails(shopId,cardNo) {
  return instance.get(`shop/listDetails?cardNo=${cardNo}&shopId=${shopId} `)
}
//员工推广小程序码
export function getStaffImg(salesman) {
  return instance.get(`main/create_sales_wx_code?salesman=${salesman}`)
}
// 员工分页数据
export function staffList(data) {
  return instance.post('user_staff/list', data)
}
// 员工新增
export function staffAddAccount(data) {
  return instance.post('user_staff/add', data)
}
// 员工编辑
export function staffEditAccount(data) {
  return instance.post(`user_staff/update`, data)
}
// 员工删除
export function staffDelAccount(objId) {
  return instance.get(`user_staff/deleted?id=${objId}`)
}
// 已支付订单退款
export function payOrderRefund(data) {
  return instance.post(`order/refund?orderId=${data.orderId}&fun=${data.fun}&uid=${data.uid}&refundAmount=${data.refundAmount}`)
}
// #################################### author: hrz ####################################
export function unbindMember(data) {
  return instance.post('account_member/member_un_bind', data)
}

export function searchCardNoApi(data) {
  return instance.post('account_member/search_member_card_no', data)
}
// 门店第三方订单核销参数查询报表
export function storeOrderThirdTicketsList(data) { 
    return instance.post(`order_third_tickets/list_page`, data)
}
// 门店第三方核销全部报表
export function storeOrderThirdAllList(data) { 
    return instance.post(`order_third_tickets/list_data`, data)
}
//门店三方核销套餐撤销
export function storeOrderThirdTicketsCancel(data) { 
    return instance.post(`order_third_tickets/cancel`, data)
}
//设置三方商户
export function storeSetThirdShop(data) { 
    return instance.post(`order_third_tickets/set_third_shop`, data)
}
// 获取三方商户
export function storeGetThirdShop(objId,type) { 
    return instance.get(`order_third_tickets/get_third_shop?ObjectId=${objId}&tag=${type}`)
}

//修改三方商户
export function storeUpdateThirdShop(data) { 
    return instance.post(`order_third_tickets/update_third_shop`, data)
}
//删除三方商户
export function storeDeleteThirdShop(id,store) { 
    return instance.post(`order_third_tickets/del_third_shop?id=${id}&store=${store}`)
}

// 获取三方套餐查询
export function storeGetThirdParms(objId,type,pageNo,pageSize) { 
    return instance.get(`order_third_tickets/get_third_parms?ObjectId=${objId}&payType=${type}&pageNo=${pageNo}&pageSize=${pageSize}`)
}

// 增加三方套餐
export function storeSetThirdParms(data) { 
    return instance.post(`order_third_tickets/set_third_parms`, data)
}

// 修改三方套餐
export function storeUpdateThirdParms(data) { 
    return instance.post(`order_third_tickets/update_third_parms`, data)
}

// 删除三方套餐
export function storeDeleteThirdParms(id,store) { 
    return instance.post(`order_third_tickets/delete_third_parms?id=${id}&store=${store}`)
}
// 设置会员卡类型
export function storeSetCardType(data) { 
    return instance.post(`order_third_tickets/setCard`,data)
}
// 获取会员卡类型
export function storeInfoCardType(storeId) { 
    return instance.get(`order_third_tickets/infoCard?storeId=${storeId}`)
}
// 删除会员卡类型
export function storeDelCardType(data) { 
    return instance.post(`order_third_tickets/delCard`,data)
}

// 周边商家增加
export function storeAddNearbyShop(data) { 
    return instance.post(`partner/merchant`,data)
}
// 周边商家修改
export function storeUpdateNearbyShop(data) { 
    return instance.put(`partner/merchant`,data)
}
// 周边商家删除
export function storeDelNearbyShop(id) { 
    return instance.delete(`partner/id?objId=${id}`)
}

// 周边商家重置密码
export function restPwd(id) { 
    return instance.put(`partner/reset?objId=${id}`)
}

// 获取周边商家列表
export function storeGetNearbyShopList(pageNum,pageSize) { 
    return instance.get(`partner/list?pageNum=${pageNum}&pageSize=${pageSize}`)
}

// 获取周边商家筛选条件
export function storeGetNearbyShopInfo(name,pageNum,pageSize) { 
    return instance.get(`partner/select?name=${name}&pageNum=${pageNum}&pageSize=${pageSize}`)
}
// 获取商家小程序二维码
export function getPartnerImg(partner_id) {
  return instance.get(`main/create_Merchant_wx_code?partner_id=${partner_id}`)
}
// 获取商家查账小程序二维码
export function getPartnerReportImg(partner_id) {
  return instance.get(`main/create_report_wx_code?partner_id=${partner_id}`)
}

// 合作商户订单列表
export function storeGetNearbyShopOrderList(pageNo,pageSize) {
    return instance.get(`partner/all?pageNo=${pageNo}&pageSize=${pageSize}`)
}

// 合作商户订单筛选
export function storeGetNearbyShopOrderInfo(data) { 
    return instance.post(`partner/filter`,data)
}

 // 合作商户订单统计
 export function storeGetNearbyShopOrderCount(partnerId,startTime,endTime) { 
    return instance.get(`partner/sum?partnerId=${partnerId}&startTime=${startTime}&endTime=${endTime}`)
}

// 获取机台信息列表
export function storeGetMachineList(data) { 
    return instance.get(`shop/device/list`,{
        params:data
    })
}

// 增加机台信息
export function storeAddMachine(data) { 
    return instance.post(`shop/device`,data)
}

export function storeEditMachine(data) { 
    return instance.put(`shop/device`,data)
}

// 删除机台信息
export function storeDelMachine(id) { 
    return instance.delete(`shop/device/delete?id=${id}`)
}

// 获机台小程序二维码
export function getDeviceImg(No) {
  return instance.get(`main/create_device_wx_code?No=${No}`)
}

// 获机台普通二维码
export function getDeviceImgSquare(deviceNo) {
  return instance.get(`main/create_device_wx_code_square?deviceNo=${deviceNo}`)
}

// 获取禁用手机号码列表
export function storeGetDisablePhoneList(data) { 
    return instance.get(`accountDisablePhone/query`,{
        params:data
    })
}

// 添加禁用手机号码
export function storeAddDisablePhone(data) { 
    return instance.post(`accountDisablePhone/add`,data)
}

export function storeEditDisablePhone(data) { 
    return instance.put(`accountDisablePhone/edit`,data)
}

// 删除禁用手机号码
export function storeDelDisablePhone(objId) { 
    return instance.delete(`accountDisablePhone/delete?objId=${objId}`)
}

// 获取邮寄开关
export function storeGetMailSwitch() { 
    return instance.get(`order_lottery/get_by_is_mail_shop_icon`)
}
// 修改邮寄功能
export function storeEditMailSwitch(data) { 
    return instance.put(`order_lottery/edit_is_mail_shop_icon`,data)
}



// 获取用户反馈列表数据
export function userList(limit, page) {
    return instance.get(`feedback/list_data?limit=${limit}&page=${page}`)
}

// 获取用户反馈列表搜索
export function userListSeach(limit, page, userPhone, isDeal) {
    return instance.get(`feedback/list_data?limit=${limit}&page=${page}&userPhone=${userPhone}&isDeal=${isDeal}`)
}

// 获取用户反馈列表详情数据
export function userListDetails(objId) {
    return instance.get(`feedback/info_detail?objId=${objId}`)
}

// 获取用户反馈列表数据处理
export function userListDeal(objId, content) {
    return instance.get(`feedback/idea_submit?objId=${objId}&content=${content}`)
}

// 获取用户反馈列表数据处理
export function userListDel(objId) {
    return instance.get(`feedback/del?objId=${objId}`)
}

// 权限馈列表详情数据
export function rightListDetails(data) {
    return instance.post('menu/page', data)
}


// 获取用户积分列表搜索
export function userIntergralList(params) {
    return instance.get(`integral/list_data`,{
        params:params
    })
}

// 获取用户积分详情数据
export function userIntergralDetails() {
    return instance.get(`integral/list_page`)
}
//修改快递单号
export function editExchangeType(params) { 
    return instance.put(`order_lottery/edit_tracking_number`,
        null,
        {params:params}
    )
}

// 获取门店合作商家列表
export function getstoresData() {
    return instance.get(`partner/list/all`)
}

// 按套餐统计
export function packageStatistics(goodsType,endDate,startDate,pageNo,pageSize) {
    return instance.get(`order_goods_count/list_data?goodsType=${goodsType}&endDate=${endDate}&startDate=${startDate}&pageNo=${pageNo}&pageSize=${pageSize}`)
}

// 获取抽奖活动规则
export function getLotteryRules() {
    return instance.get(`lottery_activity/rule_info`)
}

// 增加抽奖活动规则
export function addLotteryRules(data) {
    return instance.post(`lottery_activity/rule_add`, data)
}

// 删除抽奖活动规则
export function deleteLotteryRules(id) {
    return instance.post(`lottery_activity/rule_delete?objId=${id}`)
}

// 获取奖品列表
export function getPrizeList(name,pageNo,pageSize) {
    return instance.get(`lottery_activity/prize_list?name=${name}&pageNo=${pageNo}&pageSize=${pageSize}`)
}

// 增加、修改奖品
export function addPrize(data) {
    return instance.post(`lottery_activity/prize_add`, data)
}


// 删除奖品
export function deletePrize(id) {
    return instance.post(`lottery_activity/prize_delete?objId=${id}`)
}

// 获取颜色列表
export function getColorList() {
    return instance.get(`lottery_activity/color_list`)
}

// 抽奖奖品下架
export function editPrizeStatus(objId) {
    return instance.post(`lottery_activity/prize_status?objId=${objId}`)
}

// 获取汇付支付列表
export function getHuiFuPayList(huifuPayId,pageNo,pageSize) {
    return instance.get(`huiFuPayKey/getList?huifuPayId=${huifuPayId}&pageNo=${pageNo}&pageSize=${pageSize}`)
}

// 新增、修改汇付支付参数
export function addHuiFuPay(data) {
    return instance.post(`huiFuPayKey/add`, data)
}

// 删除汇付支付参数
export function deleteHuiFuPay(objId) {
    return instance.post(`huiFuPayKey/delete?objId=${objId}`)
}

// 上架汇付支付参数
export function onShelfHuiFuPay(objId,shelf) {
    return instance.post(`huiFuPayKey/updateShelf?objId=${objId}&shelf=${shelf}`)
}

// ========== AI对话 ==========
// 发送AI对话消息
export function sendAiChat(data) {
    return instance.post(`ai_chat/chat`, data)
}

// 创建AI对话会话
export function createAiSession(scenario) {
    return instance.get(`ai_chat/create_session?scenario=${scenario || ''}`)
}

// 获取对话历史消息
export function getAiHistory(sessionId) {
    return instance.get(`ai_chat/history?sessionId=${sessionId}`)
}


// WEBPACK FOOTER //
// ./src/api/storeApi.js